import { ReactNode } from 'react';

import { appRoutes } from '@/routes/app-routes.ts';

import {
    BookedIcon,
    DrugomaniyaIcon,
    HelpIcon,
    HomeIcon,
    MyNumbersIcon,
    ProfileIcon,
    TelegramIcon,
    VKIcon,
} from '../../icons/header/menu';

export type MenuItem = {
    name?: string;
    icon: ReactNode;
    className?: string;
    path?: string;
};

export const menuItemsList: MenuItem[] = [
    {
        name: 'Главная',
        icon: HomeIcon,
        path: '/',
    },
    {
        name: 'Мои номера',
        icon: MyNumbersIcon,
        path: appRoutes.myNumbers,
    },
    {
        name: 'Другомания',
        icon: DrugomaniyaIcon,
        path: appRoutes.drugomaniya,
    },
    {
        name: 'Брони',
        icon: BookedIcon,
        path: appRoutes.myReservations,
    },
    {
        name: 'Профиль',
        icon: ProfileIcon,
        path: appRoutes.profile,
    },
    {
        name: 'Помощь',
        icon: HelpIcon,
        path: `/${appRoutes.profile}/${appRoutes.help}`,
    },
];

export const newsList: MenuItem[] = [
    {
        icon: TelegramIcon,
        className: 'telegram-icon',
    },
    {
        icon: VKIcon,
        className: 'vk-icon',
    },
];
